<template>
  <div id="unified-toolbar" class="unified-quill-toolbar">
    <span class="ql-formats">
      <select class="ql-header" :disabled="disabled">
        <option value="1">Título 1</option>
        <option value="2">Título 2</option>
        <option value="3">Título 3</option>
        <option value="4">Título 4</option>
        <option value="5">Título 5</option>
        <option value="6">Título 6</option>
        <option selected>Normal</option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-bold" :disabled="disabled" title="Negrita" />
      <button class="ql-italic" :disabled="disabled" title="Cursiva" />
      <button class="ql-underline" :disabled="disabled" title="Subrayado" />
      <button class="ql-strike" :disabled="disabled" title="Tachado" />
    </span>
    <span class="ql-formats">
      <button
        class="ql-align"
        :disabled="disabled"
        title="Alinear izquierda"
        value=""
      />
      <button
        class="ql-align"
        :disabled="disabled"
        title="Centrar"
        value="center"
      />
      <button
        class="ql-align"
        :disabled="disabled"
        title="Alinear derecha"
        value="right"
      />
      <button
        class="ql-align"
        :disabled="disabled"
        title="Justificar"
        value="justify"
      />
    </span>
    <span class="ql-formats">
      <button
        class="ql-list"
        :disabled="disabled"
        title="Lista numerada"
        value="ordered"
      />
      <button
        class="ql-list"
        :disabled="disabled"
        title="Lista con viñetas"
        value="bullet"
      />
      <button
        class="ql-list"
        :disabled="disabled"
        title="Lista de tareas"
        value="check"
      />
    </span>
    <span class="ql-formats">
      <button
        class="ql-indent"
        :disabled="disabled"
        title="Disminuir sangría"
        value="-1"
      />
      <button
        class="ql-indent"
        :disabled="disabled"
        title="Aumentar sangría"
        value="+1"
      />
    </span>
    <span class="ql-formats">
      <select class="ql-color" :disabled="disabled" title="Color de texto" />
      <select
        class="ql-background"
        :disabled="disabled"
        title="Color de fondo"
      />
    </span>
    <span class="ql-formats">
      <button class="ql-blockquote" :disabled="disabled" title="Cita" />
      <button
        class="ql-code-block"
        :disabled="disabled"
        title="Bloque de código"
      />
    </span>
    <span class="ql-formats">
      <button class="ql-image" :disabled="disabled" title="Insertar imagen" />
      <button class="ql-link" :disabled="disabled" title="Insertar enlace" />
    </span>
    <span class="ql-formats">
      <button class="ql-clean" :disabled="disabled" title="Limpiar formato" />
    </span>
    <div v-if="!disabled" class="toolbar-actions">
      <button
        :disabled="hasHeader"
        title="Mostrar / Ocultar Encabezado"
        @click="$emit('toggle-header')"
      >
        <img src="@/assets/img/editor-header.svg" style="height: 16px;" />
        <span class="ml-2">Agregar Encabezado</span>
      </button>
      <button
        :disabled="hasFooter"
        title="Mostrar / Ocultar Pie de Página"
        @click="$emit('toggle-footer')"
      >
        <img src="@/assets/img/editor-footer.svg" style="height: 16px;" />
        <span class="ml-2">Agregar Pie de Página</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnifiedToolbar',
  props: {
    hasHeader: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.unified-quill-toolbar {
  background: #fff;
  padding: 8px 12px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex !important;
  align-items: center;
  .ql-formats {
    margin-right: 4px;
  }
  .toolbar-actions {
    margin-left: auto;
    display: flex;
    gap: 6px;
    button {
      color: #3f5b60;
      border: 1px solid #3f5b60;
      border-radius: 4px;
      width: auto;
      height: 40px;
      border-radius: 4px;
      padding: 0px 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      &:hover {
        color: #3f5b60;
      }
      &:disabled {
        cursor: default;
        opacity: 0.5;
        border: 1px solid #9e9e9e;
      }
    }
  }
}

.ql-toolbar {
  border: unset !important;
  box-shadow: unset !important;
}
</style>
